import React, { useEffect, useState } from 'react';
import ActiveTag from 'components/base/active-tag';
import { BrandType } from 'models/brand.model';
import moment from 'moment';
import ManageTrafficModal from 'components/kitchen/modals/manage-traffic-modal';
import TrafficSuccessModal from 'components/kitchen/modals/manage-traffic-modal/success-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { calculateReactivationTime } from 'utils/functions';

type Props = {
  brand: BrandType;
  isKitchenBusy?: boolean;
};

const ManageTrafficCard = (props: Props) => {
  const { isKitchenBusy } = props;
  const [brand, setBrand] = useState(props.brand);
  const [busy, setBusy] = useState(brand.is_busy);
  const [showControlModal, setShowControlModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const formattedDate = moment(brand.created_at).format('D MMM, YYYY');
  const reactivationTime = brand.reactivation_time ? moment(brand.reactivation_time) : null;
  const formatDate = reactivationTime ? reactivationTime.format('D MMM, YYYY h:mma') : null;
  const { checkReactivationTime } = useDashboardContext();

  const toggle = () => {
    setShowControlModal(true);
  };

  const updateBrand = (isBusy: boolean, reactivation_time: string) => {
    setBusy(isBusy);
    setBrand((b) => ({ ...b, reactivation_time, is_busy: isBusy }));
  };

  useEffect(() => {
    const countdown = calculateReactivationTime(brand.reactivation_time);
    if (brand.reactivation_time !== null && countdown <= 0 && busy) setBusy(false);
  }, [brand.reactivation_time, busy, checkReactivationTime]);
  return (
    <>
      <div
        onClick={toggle}
        className='min-h-[195px] overflow-hidden w-full border flex flex-col gap-[14px]  border-[#E6E5E5] rounded-[10px]'>
        <div className='flex items-center px-5 pt-5 justify-between gap-2'>
          <img src={brand.logo} alt='logo' className='w-10 h-10 object-cover rounded-full ' />

          <ActiveTag active={!busy && !isKitchenBusy} activeText='Not busy' inActiveText='Busy' />
        </div>

        <div className='flex flex-col px-5 h-[90px]'>
          <p className='font-medium text-lg'> {brand.name} </p>
          <p className='text-xs text-[#858585]'>{brand.description}</p>
        </div>
        <hr className='text-[#E6E5E5]' />
        <div className='flex items-center gap-2 px-5 pb-5'>
          {busy ? (
            <p className='text-xs text-[#595959] whitespace-nowrap'>
              Turned off till {formatDate || 'Unknown'}
            </p>
          ) : (
            <p className='text-xs text-[#595959] whitespace-nowrap'>Active since {formattedDate}</p>
          )}
        </div>
      </div>

      {showControlModal && (
        <ManageTrafficModal
          type='brand'
          open={showControlModal}
          brand={brand}
          afterMutation={updateBrand}
          onClose={() => setShowControlModal(false)}
        />
      )}

      {showSuccessModal ? (
        <TrafficSuccessModal
          title={`${brand.name} has been turned on`}
          open={showSuccessModal}
          onClose={() => setShowSuccessModal(false)}
        />
      ) : null}
    </>
  );
};

export default ManageTrafficCard;
